import { Card, Transaction } from "model";

/**
 * @class Util
 * @classdesc Class definition for record type
 * @param {OBJECT} record - The record object from this instance.
 * @example const util = Util();
 * 
 * @property {VOID}
 */
export default class Util {

    constructor(record) {
        
    }

    /**
     * @function getDefaultCard
     * @property {VOID}
     * @returns {STRING}
     * @static
     * @description - Gets the default card based on branding.
     * We can't default to a card statically (like using id "0") or the app breaks.
     * @memberof Util
     */
    static getDefaultCard(model) {
        if(model === undefined) return { id: "0" };
        const { branding } = model;
        const options = branding.options ?? {};
        const defaultCardID = options.include_debit_chw23  !== "false" ? "0" : "1";
        return Card.initByID(defaultCardID);
    }

    /**
     * @function getDefaultCardID
     * @property {VOID}
     * @returns {STRING}
     * @static
     * @description - Gets the default card id based on branding.
     * We can't default to a card statically (like using id "0") or the app breaks.
     * @memberof Util
     */
    static getDefaultCardID(model) {
        if(model === undefined) return "0";
        const { branding } = model;
        const options = branding.options ?? {};
        const defaultCardID = options.include_debit_chw23  !== "false" ? "0" : "1";
        return Card.initByID(defaultCardID).id;
    }

    /**
     * @function getDefaultTransaction
     * @property {VOID}
     * @returns {STRING}
     * @static
     * @description - Gets the default transaction based on card branding.
     * We can't default to a transaction id statically (like using id "0") or the app can breaks.
     * @memberof Util
     */
    static getDefaultTransaction(model) {
        if(model === undefined) return { id: "0" };
        const { branding } = model;
        const options = branding.options ?? {};
        const defaultCardID = options.include_debit_chw23  !== "false" ? "0" : "1";
        const transaction = Transaction.initAll().filter(transaction => transaction.card.id === defaultCardID)[0];
        return transaction;
    }

    /**
     * @function getDefaultTransactionID
     * @property {VOID}
     * @returns {STRING}
     * @static
     * @description - Gets the default transaction id based on card branding.
     * We can't default to a transaction id statically (like using id "0") or the app can breaks.
     * @memberof Util
     */
    static getDefaultTransactionID(model) {
        if(model === undefined) return "0";
        const { branding } = model;
        const options = branding.options ?? {};
        const defaultCardID = options.include_debit_chw23  !== "false" ? "0" : "1";
        const transaction = Transaction.initAll().filter(transaction => transaction.card.id === defaultCardID)[0];
        return transaction.id;
    }
}